export const localhostname = 'localhost';

export const scrollUp = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

export const scrollTo = (top, left) => window.scrollTo({ top, left, behavior: 'smooth' });

export const clickableStyles = {
  cursor: 'pointer',
  color: 'gray',
  textDecoration: 'underline',
};

export const copytoClipboard = ({ content, Swal }) => {
  try {
    const copyText = document.createElement('textarea');
    copyText.value = content;
    document.body.appendChild(copyText);
    copyText.select();
    copyText.setSelectionRange(0, 999999);
    navigator.clipboard.writeText(copyText.value);
    document.body.removeChild(copyText);
    Swal.fire('Copiado!', content);
  } catch {
    Swal.fire('Hubo un error copiando el siguiente texto:', content);
  }
};

export const changeDocTitle = (title = '', churchName = 'Comunidad Info ') => {
  if (title) title = `| ${title}`;
  try {
    if (document) {
      document.title = `${churchName}${title}`;
    }
  } catch {}
};
